import { createFileRoute } from '@tanstack/react-router';

import { redirectUnauthenticated } from '@/shared/helper/redirectUnauthenticated';

export const Route = createFileRoute('/artist/$id/_onboard')({
  beforeLoad: ({ context }) => {
    redirectUnauthenticated(context);
  }
});
